import Vue from "vue";
import Vuex from "vuex";
import { queryMyselfInfoApi } from "@/services/admin_user/index.js";
// import { queryMyselfStore } from "@/services/mall/store.js";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    //TODO:登录后的token,1天失效
    token: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航
    navList: [
      // {
      //   id: "0",
      //   label: "工作台",
      //   icon: "el-icon-s-data",
      //   routerName: "DataChart",
      //   path: "/management/dataChart",
      // },
      {
        id: "1",
        label: "系统管理",
        icon: "el-icon-setting",
        routerName: "System",
        children: [
          {
            id: "1-1",
            label: "角色账户管理",
            routerName: "SysUser",
            path: "/management/system/user",
          },
          // {
          //   id: "1-2",
          //   label: "成员管理",
          //   routerName: "AuthGroup",
          //   path: "/management/system/authGroup",
          // },
          // {
          //   id: "1-2",
          //   label: "菜单管理",
          //   routerName: "SysMenu",
          //   path: "/management/system/menu",
          // },
        ],
      },
      {
        id: "5",
        label: "工作区",
        icon: "el-icon-s-grid",
        routerName: "Workspace",
        path: "/management/workspace",
      },
      {
        id: "6",
        label: "听音乐休息区",
        icon: "el-icon-service",
        routerName: "ListenMusic",
        path: "/listenMusic",
      },
      {
        id: "2",
        label: "Mini管理",
        routerName: "Mini",
        icon: "el-icon-menu",
        children: [
          {
            id: "2-6",
            label: "数据面板",
            routerName: "MiniDashboard",
            path: "/management/mini/dashboard",
          },
          {
            id: "2-1",
            label: "平台订单",
            routerName: "MiniOrder",
            path: "/management/mini/order",
          },
          {
            id: "2-2",
            label: "用户数据",
            routerName: "MiniUser",
            path: "/management/mini/user",
          },
          {
            id: "2-3",
            label: "门店管理",
            routerName: "MiniStore",
            path: "/management/mini/store",
          },
          {
            id: "2-4",
            label: "会员卡",
            routerName: "MiniVipCard",
            path: "/management/mini/vipCard",
          },
          {
            id: "2-5",
            label: "交易记录",
            routerName: "MiniVipCardRecode",
            path: "/management/mini/vipCardRecode",
          },
        ],
      },
      {
        id: "3",
        label: "Plus管理",
        icon: "el-icon-menu",
        routerName: "Plus",
        children: [
          {
            id: "3-6",
            label: "数据面板",
            routerName: "PlusDashboard",
            path: "/management/plus/dashboard",
          },
          {
            id: "3-1",
            label: "平台订单",
            routerName: "PlusOrder",
            path: "/management/plus/order",
          },
          {
            id: "3-2",
            label: "用户数据",
            routerName: "PlusUser",
            path: "/management/plus/user",
          },
          {
            id: "3-3",
            label: "门店管理",
            routerName: "PlusStore",
            path: "/management/plus/store",
          },
          {
            id: "3-4",
            label: "会员卡",
            routerName: "PlusVipCard",
            path: "/management/plus/vipCard",
          },
          {
            id: "3-5",
            label: "交易记录",
            routerName: "PlusVipCardRecode",
            path: "/management/plus/vipCardRecode",
          },
        ],
      },
      {
        id: "4",
        label: "Mall管理",
        routerName: "Mall",
        icon: "el-icon-menu",
        children: [
          {
            id: "4-0",
            label: "数据面板",
            routerName: "MallDashboard",
            path: "/management/mall/dashboard",
          },
          {
            id: "4-1",
            label: "平台订单",
            routerName: "MallOrder",
            path: "/management/mall/order",
          },
          {
            id: "4-2",
            label: "用户数据",
            routerName: "MallUser",
            path: "/management/mall/user",
          },
          {
            id: "4-3",
            label: "入驻门店",
            routerName: "MallStore",
            path: "/management/mall/store",
          },
        ],
      },
      /* 商家子账号可配置 */
      // {
      //   id: "5",
      //   label: "商家系统管理",
      //   icon: "el-icon-setting",
      //   routerName: "MyPermission",
      //   children: [
      //     {
      //       id: "5-1",
      //       label: "账号管理",
      //       routerName: "MyPermissionUser",
      //       path: "/management/myPermission/user",
      //       //        routerName: "MallAdmin",
      //       // path: "/management/mall/admin",
      //     },
      //     {
      //       id: "5-2",
      //       label: "角色管理",
      //       routerName: "MyPermissionAuthGroup",
      //       path: "/management/myPermission/authGroup",
      //     },
      //   ],
      // },
      // {
      //   id: "6",
      //   label: "门店管理",
      //   icon: "el-icon-s-shop",
      //   routerName: "MyMall",
      //   children: [
      //     {
      //       id: "6-1",
      //       label: "我的门店",
      //       routerName: "MyMallStoreList",
      //       path: "/management/myMall/storeList",
      //     },
      //     {
      //       id: "6-2",
      //       label: "员工管理", //包括门店管理
      //       routerName: "Staff",
      //       path: "/management/myMall/staff",
      //     },
      //     {
      //       id: "6-5",
      //       label: "小程序首图",
      //       routerName: "MyMallBannerConfig",
      //       path: "/management/myMall/bannerConfig",
      //     },
      //     {
      //       id: "6-3",
      //       label: "门店商品分类",
      //       routerName: "GoodsKind",
      //       path: "/management/myMall/goods/goodsKind",
      //     },
      //     {
      //       id: "6-4",
      //       label: "门店商品",
      //       routerName: "GoodsList",
      //       path: "/management/myMall/goods/goodsList",
      //     },

      //   ],
      // },
      // {
      //   id: "7",
      //   label: "微商城",
      //   icon: "el-icon-sell",
      //   routerName: "MallGoods",
      //   children: [
      //     {
      //       id: "7-1",
      //       label: "商品分类",
      //       routerName: "MallGoodsKind",
      //       path: "/management/myMall/mallGoods/goodsKind",
      //     },
      //     {
      //       id: "7-2",
      //       label: "商品管理",
      //       routerName: "MallGoodsList",
      //       path: "/management/myMall/mallGoods/goodsList",
      //     },
      //   ],
      // },
      // {
      //   id: "8",
      //   label: "积分商城",
      //   icon: "el-icon-star-off",
      //   routerName: "IntegralGoods",
      //   children: [
      //     {
      //       id: "8-1",
      //       label: "商品分类",
      //       routerName: "IntegralGoodsKind",
      //       path: "/management/myMall/integralGoods/goodsKind",
      //     },
      //     {
      //       id: "8-2",
      //       label: "商品管理",
      //       routerName: "IntegralGoodsList",
      //       path: "/management/myMall/integralGoods/goodsList",
      //     },
      //   ],
      // },
      // {
      //   id: "9",
      //   label: "会员管理",
      //   icon: "el-icon-trophy",
      //   routerName: "MallVipCard",
      //   path: "/management/vipCard",
      //   children: [
      //     {
      //       id: "9-1",
      //       label: "会员列表",
      //       routerName: "MallVipCardList",
      //       path: "/management/myMall/vipCard/vipCardList",
      //     },
      //     {
      //       id: "9-2",
      //       label: "会员卡交易记录",
      //       routerName: "MallVipCardRecode",
      //       path: "/management/myMall/vipCard/vipCardRecode",
      //     },
      //   ],
      // },
      //营销：优惠券，大转盘
      // {
      //   id: "10",
      //   label: "优惠券管理", //包括门店管理
      //   icon: "el-icon-present",
      //   routerName: "Coupon",
      //   path: "/management/myMall/coupon",
      // },
      // {
      //   id: "11",
      //   label: "订单中心",
      //   icon: "el-icon-printer",
      //   routerName: "Person",
      //   children: [
      //     {
      //       id: "11-1",
      //       label: "小程序订单", //门店,微商城,积分商城 3大类订单
      //       icon: "el-icon-s-order",
      //       routerName: "Order",
      //       path: "/management/myMall/order",
      //     },
      //     {
      //       id: "11-2",
      //       label: "门店收银订单", //门店,微商城,积分商城 3大类订单
      //       icon: "el-icon-s-order",
      //       routerName: "Order",
      //       path: "/management/myMall/order",
      //     },
      //   ],
      // },

      {
        id: "14",
        label: "公众号通知-微服务",
        icon: "el-icon-s-comment",
        routerName: "SendService",
        children: [
          {
            id: "14-1",
            label: "基础配置",
            routerName: "BaseConfig",
            path: "/management/sendService/baseConfig",
          },
          {
            id: "14-2",
            label: "用户列表",
            routerName: "UserList",
            path: "/management/sendService/userList",
          },
          {
            id: "14-3",
            label: "通知任务",
            routerName: "TaskManage",
            path: "/management/sendService/taskManage",
          },
          {
            id: "14-4",
            label: "发送记录",
            routerName: "RecordList",
            path: "/management/sendService/recordList",
          },
          {
            id: "14-5",
            label: "api文档",
            routerName: "SendDoc",
            path: "/management/sendService/doc",
          },
        ],
      },

      {
        id: "12",
        label: "个人页",
        icon: "el-icon-s-custom",
        routerName: "Person",
        children: [
          {
            id: "12-1",
            label: "个人中心",
            routerName: "PersonCenter",
            path: "/management/person/center",
          },
        ],
      },
      // {
      //   id: "13",
      //   label: "商家服务",
      //   icon: "el-icon-s-comment",
      //   routerName: "Examine",
      //   children: [
      //     {
      //       id: "13-1",
      //       label: "续费",
      //       routerName: "Payment",
      //       path: "/management/merchant/payment",
      //     },

      //     {
      //       id: "13-2",
      //       label: "使用指南",
      //       routerName: "",
      //       path: "",
      //     },
      //     {
      //       id: "13-3",
      //       label: "意见反馈",
      //       routerName: "",
      //       path: "",
      //     },
      //   ],
      // },
    ],

    //登录后筛选的导航
    filterNavList: [],
    //登录后筛选的店铺列表
    filterStoreList: [],
    //高亮导航项
    active: "",
  },

  // Mutations: 同步修改状态的方法
  mutations: {
    // 更新用户信息（包含token、权限等）
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    // 更新过滤后的导航列表（根据用户权限筛选）
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    // 更新过滤后的店铺列表
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    // 更新当前激活的导航项
    updataActive(state, value) {
      state.active = value;
    },
  },
  // Actions: 异步操作和业务逻辑处理
  actions: {
    /**
     * 获取用户信息并初始化权限和门店信息
     * @description 登录后或刷新页面时调用，完成用户信息、权限、门店等数据的初始化
     * @returns {Promise} 返回包含 code 和 routerName 的对象
     */
    async getUserInfoAction({ commit, state, dispatch }) {
      // 从本地存储获取 token
      const token = localStorage.getItem("token");

      // 调用接口获取用户信息
      const userInfo = await queryMyselfInfoApi({
        token,
      });

      // 用户无权限或 token 失效时拦截
      if (userInfo?.code !== 200 || !userInfo?.data?.role_menu) {
        return new Promise((reslove, reject) => {
          reslove(userInfo);
        });
      }

      // console.log("userInfo:===================", userInfo);

      // 提交用户信息到 state（此时 userInfo 已包含 token）
      commit("updataUserInfo", userInfo?.data);

      // 初始化店铺信息
      // const storeList = await queryMyselfStore({
      //   store_id: userInfo?.data.store_id || "",
      // });
      // commit("updataFilterStoreList", storeList?.data);

      // 根据用户权限初始化导航数据
      // 深拷贝全量导航列表，避免修改原始数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));
      // 将用户权限字符串转换为数组（如 "0,1,1-1" => ["0", "1", "1-1"]）
      var roleList = state.userInfo.role_menu?.split(",");

      // 递归筛选出用户有权限的导航项
      await dispatch("getFilterNavListAction", {
        copyNavList,
        roleList,
      });

      // 提交筛选后的导航列表
      commit("updataFilterNavList", copyNavList);

      // 返回成功状态，跳转到欢迎页
      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName: "Welcome",
        });
      });
    },

    /**
     * 根据权限递归筛选出导航列表
     * @description 根据用户权限过滤导航菜单，移除无权限的菜单项
     * @param {Array} copyNavList - 导航列表副本
     * @param {Array} roleList - 用户权限ID列表
     */
    async getFilterNavListAction(
      { dispatch, commit },
      { copyNavList, roleList }
    ) {
      // 从后向前遍历，避免删除元素时索引错乱
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        // 如果当前菜单有子菜单且用户有该菜单权限，递归处理子菜单
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        // 如果用户没有该菜单权限，从列表中移除
        if (roleList?.indexOf(copyNavList[index]?.id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },


    /**
     * 查找并激活当前路由对应的导航菜单项
     * @description 递归遍历导航列表,根据路由路径找到对应的菜单项并设置为激活状态
     * @param {Object} context - Vuex action 上下文对象
     * @param {Function} context.dispatch - 分发其他 action
     * @param {Function} context.commit - 提交 mutation
     * @param {Object} payload - 传入参数
     * @param {Array} payload.filterNavList - 过滤后的导航列表
     * @param {String} payload.path - 当前路由路径
     * @returns {Boolean} 是否找到匹配的导航项
     */
    async findActive({ dispatch, commit }, { filterNavList, path }) {
      // 遍历导航列表
      for (let index = 0; index < filterNavList.length; index++) {
        const navItem = filterNavList[index];

        // 找到路径匹配的导航项,更新激活状态
        if (navItem?.path === path) {
          commit("updataActive", navItem.id);
          return true; // 找到后直接返回
        }

        // 如果当前菜单有子菜单且路径不匹配,递归查找子菜单
        if (navItem?.children?.length > 0) {
          const found = await dispatch("findActive", {
            filterNavList: navItem.children,
            path,
          });
          // 子菜单中找到了,提前结束循环
          if (found) return true;
        }
      }
      // 未找到匹配项,清空激活状态
      commit("updataActive", "");
      return false;
    },
  },
});
export default store;
